import React from 'react';
import EndOfSyncProcessUserLine from "Components/UsersView/endOfSyncProcessUserLine";
import 'Styles/usersView/endOfSyncProcessModal.scss';

const EndOfSyncProcessModal = (props) => {
    return (
        <div className='smr-table'>
            <div className='lines-container overflowing-element'>
                {props.usersReloadResult.map(syncUserInfo => (
                    <EndOfSyncProcessUserLine
                        key={syncUserInfo.name}
                        syncUserInfo={syncUserInfo} />
                ))}
            </div>
        </div>
    );
}

export default EndOfSyncProcessModal;